
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getThemeClasses } from "./recipe-generator/RecipeGeneratorTheme";
import RecipeFilters from "./recipe-generator/RecipeFilters";
import GeneratorActions from "./recipe-generator/GeneratorActions";
import RecipeResults from "./recipe-generator/RecipeResults";
import RecipeDetails from "./recipe-generator/RecipeDetails";
import { useRecipeGenerator } from "./recipe-generator/useRecipeGenerator";
import { RecipeGeneratorProps } from "@/components/admin/tools/recipe-ideas/types";

const RecipeGenerator: React.FC<RecipeGeneratorProps> = ({ 
  theme = "default",
  instanceId = "default",
  postId
}) => {
  const {
    recipes,
    selectedRecipe,
    setSelectedRecipe,
    isLoading,
    error,
    usageCount,
    selectedCategory,
    setSelectedCategory,
    selectedDifficulty,
    setSelectedDifficulty,
    kidFriendlyOnly,
    setKidFriendlyOnly,
    generateIdeas,
    resetFilters
  } = useRecipeGenerator({ instanceId, postId });

  const themeClasses = getThemeClasses(theme);

  return (
    <Card className={`w-full my-6 ${themeClasses.cardClass}`}>
      <CardHeader>
        <CardTitle className={themeClasses.titleClass}>
          Holiday Elf Recipe Generator
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {!selectedRecipe ? (
            <>
              <div>
                <h3 className="text-lg font-medium mb-3">Find Holiday Recipes:</h3>
                <RecipeFilters 
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  selectedDifficulty={selectedDifficulty}
                  setSelectedDifficulty={setSelectedDifficulty}
                  kidFriendlyOnly={kidFriendlyOnly}
                  setKidFriendlyOnly={setKidFriendlyOnly}
                  themeClasses={themeClasses}
                />
              </div>

              <GeneratorActions 
                onGenerateIdeas={generateIdeas}
                onReset={resetFilters}
                themeClasses={themeClasses}
              />

              {isLoading ? (
                <div className="p-6 text-center">
                  <p className="text-lg">Loading recipes...</p>
                </div>
              ) : error ? (
                <div className="p-6 text-center bg-red-50 rounded-lg">
                  <p className="text-red-600">{error}</p>
                </div>
              ) : (
                <RecipeResults 
                  recipes={recipes}
                  themeClasses={themeClasses}
                  selectedRecipe={selectedRecipe}
                  setSelectedRecipe={setSelectedRecipe}
                />
              )}
            </>
          ) : (
            <RecipeDetails 
              recipe={selectedRecipe}
              themeClasses={themeClasses}
              onBack={() => setSelectedRecipe(null)}
            />
          )}
          
          <div className="text-xs text-gray-500 text-right">
            Tool usage count: {usageCount}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RecipeGenerator;
